/*
* js tracking
*/
AndApp = {};
AndApp.Raven = {};
AndApp.Raven.init = function(dsn) {
    var Raven             = require('raven-js'),
        wrapConsoleMethod = require('raven-js/src/console').wrapMethod;

    Raven
        .config(dsn)
        .addPlugin(function(Raven) {
            wrapConsoleMethod(console, 'error', function(msg, data) {
            Raven.captureMessage(msg, data);
        });
    })
    .install();
};
